import React, { useState, useEffect, useCallback } from "react";
import { Row, Col } from "antd";

import { isUserReader } from "../../modules/session";
import { getEntities } from "../../modules/crudOperations";
import { useUserRole } from "../../modules/redux/session/useAuth";
import InvoiceListTable from "../../components/invoiceList/invoiceListTable";
import InvoiceListFilter from "../../components/invoiceList/invoiceListFilter";
import InvoiceListHeader from "../../components/invoiceList/invoiceListHeader";
import { parseDate, parseItemAmount } from "../../modules/consignmentFunctions";

function InvoiceList() {
  const [workInvoices, setWorkInvoices] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);

  const [invoices, setInvoices] = useState();
  const loadInvoices = useCallback(
    (parameters) => {
      setSelectedInvoices([]);
      getEntities(
        "invoice",
        setInvoices,
        (i) => ({
          key: i.id,
          invoice: i,
          code: i.code,
          state: i.state,
          invoiceType: i.invoiceType,
          issueDate: parseDate(i.issueDateTime),
          taxableDate: parseDate(i.taxableDateTime),
          dueDate: parseDate(i.dueDateTime),
          payDate: parseDate(i.payDateTime),
          daysAfterDueDate: i.daysAfterDueDate || "--",
          amount: parseItemAmount(i),
        }),
        parameters,
      );
    },
    [setSelectedInvoices],
  );

  const [allSelected, setAllSelected] = useState(false);
  const handleSelectClick = useCallback(() => {
    if (invoices && invoices.length > 0) {
      setSelectedInvoices(allSelected ? [] : invoices.map((a) => a.key));
    }
  }, [invoices, allSelected]);

  const [showFilter, setShowFilter] = useState();
  const handleFilterClick = useCallback(() => {
    setShowFilter(!showFilter);
  }, [showFilter]);

  const reader = isUserReader(useUserRole());

  useEffect(() => {
    invoices &&
      invoices !== "e" &&
      setWorkInvoices(invoices.filter((a) => selectedInvoices.includes(a.key)));
  }, [invoices, selectedInvoices]);

  useEffect(() => {
    setAllSelected(
      invoices &&
        invoices.length > 0 &&
        selectedInvoices.length === invoices.length,
    );
  }, [invoices, selectedInvoices]);

  return (
    <Row>
      <Col>
        <InvoiceListHeader
          invoices={invoices}
          showFilter={showFilter}
          disabledOptions={reader}
          allSelected={allSelected}
          workInvoices={workInvoices}
          onFilterClick={handleFilterClick}
          onSelectClick={handleSelectClick}
        />
        <InvoiceListFilter
          showFilter={showFilter}
          loadInvoices={loadInvoices}
          onSetShowFilter={setShowFilter}
        />
        <InvoiceListTable
          invoices={invoices}
          loadInvoices={loadInvoices}
          selectedInvoices={selectedInvoices}
          setSelectedInvoices={setSelectedInvoices}
        />
      </Col>
    </Row>
  );
}

export default InvoiceList;
